import React, {useState, useEffect} from "react";
import "./LanguageChanger.css";
import { useTranslation } from "react-i18next";

const LanguageChanger = (props) => {
    const { t, i18n } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

    const pageClass = props.currentPage === "home" ? "selected-language-home" : "selected-language";

    useEffect(() => {
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem('language', selectedLanguage.toUpperCase());
    }, [selectedLanguage]);

    const changeLanguage = (language) => {
        setSelectedLanguage(language);
    }

    const compareLanguage = (language) => {
        return selectedLanguage === language ? pageClass : '';
    }
    
    return (
        <div className={props.currentPage === "home" ? "languages-home" : "languages"}>
            <span onClick={() => changeLanguage('pt')} className={compareLanguage('pt')}>PT</span>
            <span onClick={() => changeLanguage('es')} className={compareLanguage('es')}>ES</span>
            <span onClick={() => changeLanguage('en')} className={compareLanguage('en')}>EN</span>
        </div>
    )
}

export default LanguageChanger;